import { render, staticRenderFns } from "./SchematicImg.vue?vue&type=template&id=2e9a3d62&scoped=true"
import script from "./SchematicImg.vue?vue&type=script&lang=js"
export * from "./SchematicImg.vue?vue&type=script&lang=js"
import style0 from "./SchematicImg.vue?vue&type=style&index=0&id=2e9a3d62&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_d02125917f7c66a571cdcbfa3dd68341/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a3d62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e9a3d62')) {
      api.createRecord('2e9a3d62', component.options)
    } else {
      api.reload('2e9a3d62', component.options)
    }
    module.hot.accept("./SchematicImg.vue?vue&type=template&id=2e9a3d62&scoped=true", function () {
      api.rerender('2e9a3d62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/consult/components/SchematicImg.vue"
export default component.exports